document.addEventListener('DOMContentLoaded', function () {
  var container = document.querySelector('.color-swatches');
  if (!container) return;

  var labelValue = container.querySelector('.color-swatches__label-value');
  var defaultLabel = container.dataset.currentLabel;

  // Save scroll position on swatch click for smooth navigation
  container.addEventListener('click', function (e) {
    var swatch = e.target.closest('.color-swatches__swatch');
    if (swatch) {
      sessionStorage.setItem('swatch-scroll-position', String(window.scrollY));
    }
  });

  // Hover/focus color label
  container.addEventListener('mouseover', function (e) {
    var swatch = e.target.closest('.color-swatches__swatch');
    if (swatch && labelValue) {
      labelValue.textContent = swatch.dataset.colorLabel;
    }
  });

  container.addEventListener('mouseout', function (e) {
    var swatch = e.target.closest('.color-swatches__swatch');
    if (swatch && labelValue) {
      labelValue.textContent = defaultLabel;
    }
  });

  container.addEventListener('focusin', function (e) {
    var swatch = e.target.closest('.color-swatches__swatch');
    if (swatch && labelValue) {
      labelValue.textContent = swatch.dataset.colorLabel;
    }
  });

  container.addEventListener('focusout', function (e) {
    var swatch = e.target.closest('.color-swatches__swatch');
    if (swatch && labelValue) {
      labelValue.textContent = defaultLabel;
    }
  });

  // Size persistence across swatch navigation
  var params = new URLSearchParams(window.location.search);
  var sizeParam = params.get('size');

  function updateSwatchLinks(size) {
    var swatches = container.querySelectorAll('.color-swatches__swatch');
    swatches.forEach(function (swatch) {
      var url = new URL(swatch.href);
      if (size) {
        url.searchParams.set('size', size);
      } else {
        url.searchParams.delete('size');
      }
      swatch.href = url.toString();
    });
  }

  function updateSwatchAvailability(size) {
    var swatches = container.querySelectorAll('.color-swatches__swatch');
    swatches.forEach(function (swatch) {
      var colorLabel = swatch.dataset.colorLabel;
      var isSoldOut;

      if (size) {
        var availability = JSON.parse(swatch.dataset.sizeAvailability || '{}');
        // If size key doesn't exist, treat as available
        isSoldOut = size in availability ? !availability[size] : false;
      } else {
        isSoldOut = swatch.dataset.productAvailable === 'false';
      }

      swatch.classList.toggle('color-swatches__swatch--sold-out', isSoldOut);
      swatch.title = colorLabel + (isSoldOut ? ' (Sold Out)' : '');
      swatch.setAttribute('aria-label', colorLabel + (isSoldOut ? ' - Sold Out' : ''));
    });
  }

  function findSizeFieldset() {
    var fieldsets = document.querySelectorAll('variant-selects .product-form__input--pill');
    for (var i = 0; i < fieldsets.length; i++) {
      var legend = fieldsets[i].querySelector('.form__label');
      if (legend && legend.textContent.trim() === 'Size') {
        return fieldsets[i];
      }
    }
    return null;
  }

  var sizeFieldset = findSizeFieldset();

  // Pre-select size from URL parameter
  if (sizeParam && sizeFieldset) {
    var inputs = sizeFieldset.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].value === sizeParam && !inputs[i].classList.contains('disabled')) {
        inputs[i].checked = true;
        inputs[i].dispatchEvent(new Event('change', { bubbles: true }));
        break;
      }
    }
    updateSwatchLinks(sizeParam);
    updateSwatchAvailability(sizeParam);
  }

  // Update swatch links and availability when size changes
  if (sizeFieldset) {
    sizeFieldset.addEventListener('change', function (e) {
      if (e.target.type === 'radio') {
        updateSwatchLinks(e.target.value);
        updateSwatchAvailability(e.target.value);
      }
    });
  }
});
